// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
    scrollbar-width: none; 
    -ms-overflow-style: none; 
  }
  
  body::-webkit-scrollbar {
    width: 0; 
  } */

/* css add for giftcard  new scrollbar */
  .scroll_product{
    width: 100%;
    max-height: 470px;
    overflow-y: auto;
  }

  /* width */
body::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
body::-webkit-scrollbar-track {
  background: #65B5FF;
  border-radius: 10px;
}

/* Handle */
body::-webkit-scrollbar-thumb {
  background: #2665F2;
  border-radius: 10px;
}

/* Handle on hover */
body::-webkit-scrollbar-thumb:hover {
  background: #2665F2;
  border-radius: 10px;
}


.centar_product_listing  .container{
  width: 100%;
  max-width: 1256px !important;
}
.centar_product_listing .container .row .card_child .listing-block {
  max-width: 285px;
  margin: 0 auto;
  padding: 15px !important;
    display: flex;
    min-height: 187px;
    flex-direction: column;
    justify-content: space-between;
    height: 100% !important;
}


.centar_product_listing .container .row .card_child .listing-block .form-select {
  padding: 5px 10px;
}
.centar_product_listing .container .row .card_child .listing-top {
  margin-bottom: 14px;
}

.centar_product_listing .container .row .card_child .listing-bottom {
  margin-bottom: -10px;
}


@media (min-width:1200px) and (max-width:1300px) {
  .centar_product_listing .container .row .card_child .listing-block .listing-name {
      min-height: 20px !important;
      line-height: 17px !important;
  }

}



.centar_product_listing .container .row .card_child .listing-top .listing-name {
  min-height: 20px;
  line-height: 17px; 
}
@media screen and (min-width: 992px) and (max-width: 1199.98px){
  .centar_product_listing .container .row .card_child .listing-top .listing-name {
    min-height: 35px;
    line-height: 17px;
}

.listing-bottom-right.active {
 position: relative !important;
 bottom: 10px !important;
}
}

@media screen and (max-width: 992px){

.centar_product_listing .container .row .card_child .listing-block {
  padding: 20px !important;
}
}

.listing-bottom-right.active h6{
margin: 0 auto !important;
}

.css-1fdsijx-ValueContainer{
  padding: 2px 3px !important;
}
.css-9srrux-singleValue{
  font-size: 16px !important;
}
.css-1xc3v61-indicatorContainer{
  padding: 8px 0px !important;
}
.css-15lsz6c-indicatorContainer{
  padding: 8px 0px !important;
}

@media screen and (min-width: 1200px) {
  .customMarginGiftcards{
    margin: 0px 15px;
  }
}

.custom-container { 
  max-width: 1300px !important; /* Adjust the max-width as per your requirement */
  margin: 0 auto; /* Center align the container */
  padding: 0 15px; /* Optional: Add some padding for better spacing */
}

 @media screen and (max-width: 1440px) and (min-width: 1024px) {
  .custom-container {
    max-width: 90%; 
    padding: 0 7%; 
    margin: 0 auto; 
  }

  /* .custom-container .d-flex .add_button_New{
   padding:  0 2%;
   padding: 0px 10px;
   margin: 0 auto;
  } */

} 

@media screen and (max-width: 1500px) and (min-width: 1024px){
  .zoomScreen{
    zoom: 0.8;
  }
  .checkout_offcanvas {
    /* height: calc(-129px + 100vh + 20%)!important; */
      zoom: 0.8;
  }
}
@media screen and (max-width: 1400px) {
  .zoomScreen{
    zoom: 0.8;
  }
  .checkout_offcanvas {
    /* height: calc(-179px + 100vh + 20%)!important; */
      zoom: 0.8;
  }
}
@media screen and (max-width: 676px) {
  .zoomScreen{
    zoom: 0.8;
  }
  .checkout_offcanvas {
    /* height: calc(-179px + 100vh + 23%)!important; */
      zoom: 0.8;
  }
}

.checkout_offcanvas {
  bottom:0!important;
  /* top:unset!important; */
}
.checkout_offcanvas_content{
   bottom: 0px !important;
  /* top: auto !important; */
  max-width: 400px !important;
  /* height: 86.60% !important; */
  border: grey !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  /* position: invert-layer !important; */
  
}
/* @media screen and (max-width: 1500px) and (min-width: 1400px){
  .checkout_offcanvas_content{
      height: 89.60% !important;
  }
}
@media screen and (max-width: 1400px) and (min-width: 1024px){
  .checkout_offcanvas_content{
      height: 85.60% !important;
  }
}
@media screen and (max-width: 1024px) and (min-width: 992px) {
  .checkout_offcanvas_content{
      height: 81.60% !important;
  }
}
@media screen and (max-width: 992px) and (min-width: 600px) {
  .checkout_offcanvas_content{
      height: 86.60% !important;
  }
}
@media screen and (max-width: 500px) and (min-width: 475px) {
  .checkout_offcanvas_content{
      height: 86.60% !important;
  }
}
@media screen and (max-width: 475px) and (min-width: 450px) {
  .checkout_offcanvas_content{
      height: 83.60% !important;
  }
} */

@media screen and (max-width: 1440px) and (min-width: 1024px) {
  .card-footer{
    padding: 8px 10px;
  }
  .card-body{
    padding: 0px 10px;
  }
}

.close-icon {
  position: absolute;
  right: 26px;
  top: 12px;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

@media screen and (max-width: 992px) {
  .close-icon {
    right: 10px;
    top: 12px;
    font-size: 18px;
    cursor: pointer;
    transition: transform 0.3s ease;
  }
}

.close-icon:hover {
  transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/styles/giftcard.css"],"names":[],"mappings":"AAAA;;;;;;;KAOK;;AAEL,wCAAwC;EACtC;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,UAAU;AACZ;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,wBAAwB;IACtB,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;AAC3B;;;AAGA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE;MACI,2BAA2B;MAC3B,4BAA4B;EAChC;;AAEF;;;;AAIA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;CACC,6BAA6B;CAC7B,uBAAuB;AACxB;AACA;;AAEA;;AAEA;EACE,wBAAwB;AAC1B;AACA;;AAEA;AACA,yBAAyB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,4BAA4B,EAAE,iDAAiD;EAC/E,cAAc,EAAE,+BAA+B;EAC/C,eAAe,EAAE,kDAAkD;AACrE;;CAEC;EACC;IACE,cAAc;IACd,aAAa;IACb,cAAc;EAChB;;EAEA;;;;KAIG;;AAEL;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,kDAAkD;MAChD,SAAS;EACb;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,kDAAkD;MAChD,SAAS;EACb;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;IACE,kDAAkD;MAChD,SAAS;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;GACG,sBAAsB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;EACvB,mDAAmD;EACnD,uCAAuC;;AAEzC;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;;AAEH;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE;IACE,WAAW;IACX,SAAS;IACT,eAAe;IACf,eAAe;IACf,+BAA+B;EACjC;AACF;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* body {\n    scrollbar-width: none; \n    -ms-overflow-style: none; \n  }\n  \n  body::-webkit-scrollbar {\n    width: 0; \n  } */\n\n/* css add for giftcard  new scrollbar */\n  .scroll_product{\n    width: 100%;\n    max-height: 470px;\n    overflow-y: auto;\n  }\n\n  /* width */\nbody::-webkit-scrollbar {\n  width: 5px;\n  border-radius: 10px;\n}\n\n/* Track */\nbody::-webkit-scrollbar-track {\n  background: #65B5FF;\n  border-radius: 10px;\n}\n\n/* Handle */\nbody::-webkit-scrollbar-thumb {\n  background: #2665F2;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\nbody::-webkit-scrollbar-thumb:hover {\n  background: #2665F2;\n  border-radius: 10px;\n}\n\n\n.centar_product_listing  .container{\n  width: 100%;\n  max-width: 1256px !important;\n}\n.centar_product_listing .container .row .card_child .listing-block {\n  max-width: 285px;\n  margin: 0 auto;\n  padding: 15px !important;\n    display: flex;\n    min-height: 187px;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100% !important;\n}\n\n\n.centar_product_listing .container .row .card_child .listing-block .form-select {\n  padding: 5px 10px;\n}\n.centar_product_listing .container .row .card_child .listing-top {\n  margin-bottom: 14px;\n}\n\n.centar_product_listing .container .row .card_child .listing-bottom {\n  margin-bottom: -10px;\n}\n\n\n@media (min-width:1200px) and (max-width:1300px) {\n  .centar_product_listing .container .row .card_child .listing-block .listing-name {\n      min-height: 20px !important;\n      line-height: 17px !important;\n  }\n\n}\n\n\n\n.centar_product_listing .container .row .card_child .listing-top .listing-name {\n  min-height: 20px;\n  line-height: 17px; \n}\n@media screen and (min-width: 992px) and (max-width: 1199.98px){\n  .centar_product_listing .container .row .card_child .listing-top .listing-name {\n    min-height: 35px;\n    line-height: 17px;\n}\n\n.listing-bottom-right.active {\n position: relative !important;\n bottom: 10px !important;\n}\n}\n\n@media screen and (max-width: 992px){\n\n.centar_product_listing .container .row .card_child .listing-block {\n  padding: 20px !important;\n}\n}\n\n.listing-bottom-right.active h6{\nmargin: 0 auto !important;\n}\n\n.css-1fdsijx-ValueContainer{\n  padding: 2px 3px !important;\n}\n.css-9srrux-singleValue{\n  font-size: 16px !important;\n}\n.css-1xc3v61-indicatorContainer{\n  padding: 8px 0px !important;\n}\n.css-15lsz6c-indicatorContainer{\n  padding: 8px 0px !important;\n}\n\n@media screen and (min-width: 1200px) {\n  .customMarginGiftcards{\n    margin: 0px 15px;\n  }\n}\n\n.custom-container { \n  max-width: 1300px !important; /* Adjust the max-width as per your requirement */\n  margin: 0 auto; /* Center align the container */\n  padding: 0 15px; /* Optional: Add some padding for better spacing */\n}\n\n @media screen and (max-width: 1440px) and (min-width: 1024px) {\n  .custom-container {\n    max-width: 90%; \n    padding: 0 7%; \n    margin: 0 auto; \n  }\n\n  /* .custom-container .d-flex .add_button_New{\n   padding:  0 2%;\n   padding: 0px 10px;\n   margin: 0 auto;\n  } */\n\n} \n\n@media screen and (max-width: 1500px) and (min-width: 1024px){\n  .zoomScreen{\n    zoom: 0.8;\n  }\n  .checkout_offcanvas {\n    /* height: calc(-129px + 100vh + 20%)!important; */\n      zoom: 0.8;\n  }\n}\n@media screen and (max-width: 1400px) {\n  .zoomScreen{\n    zoom: 0.8;\n  }\n  .checkout_offcanvas {\n    /* height: calc(-179px + 100vh + 20%)!important; */\n      zoom: 0.8;\n  }\n}\n@media screen and (max-width: 676px) {\n  .zoomScreen{\n    zoom: 0.8;\n  }\n  .checkout_offcanvas {\n    /* height: calc(-179px + 100vh + 23%)!important; */\n      zoom: 0.8;\n  }\n}\n\n.checkout_offcanvas {\n  bottom:0!important;\n  /* top:unset!important; */\n}\n.checkout_offcanvas_content{\n   bottom: 0px !important;\n  /* top: auto !important; */\n  max-width: 400px !important;\n  /* height: 86.60% !important; */\n  border: grey !important;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;\n  /* position: invert-layer !important; */\n  \n}\n/* @media screen and (max-width: 1500px) and (min-width: 1400px){\n  .checkout_offcanvas_content{\n      height: 89.60% !important;\n  }\n}\n@media screen and (max-width: 1400px) and (min-width: 1024px){\n  .checkout_offcanvas_content{\n      height: 85.60% !important;\n  }\n}\n@media screen and (max-width: 1024px) and (min-width: 992px) {\n  .checkout_offcanvas_content{\n      height: 81.60% !important;\n  }\n}\n@media screen and (max-width: 992px) and (min-width: 600px) {\n  .checkout_offcanvas_content{\n      height: 86.60% !important;\n  }\n}\n@media screen and (max-width: 500px) and (min-width: 475px) {\n  .checkout_offcanvas_content{\n      height: 86.60% !important;\n  }\n}\n@media screen and (max-width: 475px) and (min-width: 450px) {\n  .checkout_offcanvas_content{\n      height: 83.60% !important;\n  }\n} */\n\n@media screen and (max-width: 1440px) and (min-width: 1024px) {\n  .card-footer{\n    padding: 8px 10px;\n  }\n  .card-body{\n    padding: 0px 10px;\n  }\n}\n\n.close-icon {\n  position: absolute;\n  right: 26px;\n  top: 12px;\n  font-size: 18px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n@media screen and (max-width: 992px) {\n  .close-icon {\n    right: 10px;\n    top: 12px;\n    font-size: 18px;\n    cursor: pointer;\n    transition: transform 0.3s ease;\n  }\n}\n\n.close-icon:hover {\n  transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
